module.exports = __webpack_public_path__ + "img/Inventory.335332d4.svg";